import './index.scss'
import React, { ReactNode, useEffect, useState } from 'react';
import { Header } from '../components/Header';
import { Content } from '../components/Content';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStore } from '../store';
import { isLinkValid } from '../services/link-verfication';
import { t } from 'i18next';
import { ClipLoader } from 'react-spinners';
import { notify } from '../components/Toast';

interface LayoutProps {
  children: ReactNode,
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const { invite, setInvite } = useStore();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }
  const query = useQuery();
  const uuid = query?.get('uuid');
  
  const getInvitationData = async (id: string | null) => {
    try {
      setLoader(true);
      const data = await isLinkValid(id);
      setInvite(data);
      setLoader(false);
    } catch (error) {
      notify(t('URL not valid'), 'error');
      setLoader(false);
    }
  }

  useEffect(() => {
    uuid && getInvitationData(uuid);
    invite?.status === 'inactive' && navigate('/expired-invitation');
  }, []);

  useEffect(() => {
    invite?.status === 'inactive' && navigate('/expired-invitation');
  }, [invite]);

  return (
    <>
      {loader ? 
        <ClipLoader 
          cssOverride={{
            left: '48%',
            position: 'absolute',
            top: '50%'
          }}
          speedMultiplier={1}
          color='#612eb3' size={60} 
        /> 
        : <div className='container'>
            <Header />
            <Content>{children}</Content>
        </div>
      }
    </>
  );
}

export default Layout;